/** Разделы, скрытые в налоговом режиме (директор/админ). Панель управления, врачи, услуги, отчёты, приём, пациенты остаются. */

export const TAX_HIDDEN_ADMIN_PATHS = [
  '/finance',
  '/payments',
  '/pharmacy',
  '/attendance',
  '/feedback-inbox',
  '/settings',
  '/templates',
];

/** В V2 (зеркало) у директора нет вкладок «Финансы» и «Отчёты». В V1 они остаются. */
export const MIRROR_HIDDEN_ADMIN_PATHS = [
  '/finance',
  '/reports',
  '/reports/monthly',
];

export function userUsesTaxView(user) {
  if (!user) return false;
  const canToggle = Boolean(user.isDirector || user.isAdmin || user.role === 'director' || user.role === 'admin');
  if (!canToggle) return false;
  const mode = user.accountingViewMode || user.accounting_view_mode || 'internal';
  return mode === 'tax';
}

export function userUsesMirrorLedger(user) {
  if (!user) return false;
  const ledger = user.activeLedger || user.active_ledger || 'primary';
  return ledger === 'mirror';
}

export function isRouteHiddenInTaxView(path) {
  if (!path) return false;
  const base = path.split('/:')[0];
  return TAX_HIDDEN_ADMIN_PATHS.includes(base);
}

export function isRouteHiddenInMirrorLedger(path) {
  if (!path) return false;
  const base = path.split('/:')[0];
  return MIRROR_HIDDEN_ADMIN_PATHS.includes(base) || base.startsWith('/reports');
}
